export default __webpack_public_path__ + "static/whatsappPageHeroBg-84156b573f789d758f82cb5096f845c5.png";